export const FORM_FIELD_LABEL_PLACEHOLDER =
  'Example: What was the most enjoyable part of your experience?';
